<template>
    <div>
        <form class="change-password-form" @submit="submit">
            <div v-if="saved" class="alert alert-success">
                Данные сохранены
            </div>
            <div v-if="error" class="alert alert-danger" v-html="error"></div>
            <text-input name="oldPassword" type="password" label="Старый пароль" :required="true"
                        v-model="oldPassword"></text-input>
            <text-input name="newPassword" type="password" label="Новый пароль" :required="true"
                        v-model="newPassword"></text-input>
            <text-input name="repeatPassword" type="password" label="Подтверждение пароля"
                        :required="true" v-model="repeatPassword"></text-input>
            <btn :loading="loading"></btn>
        </form>
    </div>
</template>

<script>
  import TextInput from '../../form/TextInput'
  import Btn from '../../form/Btn'
  import axios from 'axios'

  export default {
    name: 'change-password',
    components: {Btn, TextInput},
    data () {
      return {
        oldPassword: '',
        newPassword: '',
        repeatPassword: '',
        error: '',
        saved: false,
        loading: false
      }
    },
    methods: {
      async submit ($event) {
        console.log($event)
        $event.preventDefault()
        this.loading = true

        try {
          await axios.post('personal/password', new FormData($event.target))
          this.saved = true
          this.cleanInputs()
          setTimeout(() => {
            this.saved = false
          }, 5000)

          this.loading = false
        } catch (e) {
          this.error = e.response.data.error
          this.loading = false
        }
      },
      cleanInputs () {
        this.oldPassword = ''
        this.newPassword = ''
        this.repeatPassword = ''
      }
    }
  }
</script>

<style lang="scss" scoped>
    .change-password-form {
        margin-top: 20px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Personal/PersonalProfile/ChangePassword.vue